import { createContext } from 'react';

export const ModalContext = createContext({} as any);
export const ModalProvider = ModalContext.Provider;
